export interface ITheme {
  colors: {
    accent: string;
    dark: string;
    light: string;
    primary: string;
    secondary: string;
    grey: string;
    greyish: string;
    blueish: string;
    pinkish: string;
    white: string;
    bg1: string;
    bg2: string;
    green: string;
    red: string;
  };
}

export const theme: ITheme = {
  colors: {
    accent: "#ED2C7F", // pink
    dark: "#191F2D", // really dark blue
    light: "#CCDFFF", // light blue
    primary: "#26324C", // dark blue
    secondary: "#718096", // dark grey

    pinkish: "#FFEAF3", //
    grey: "#A0AEC0", // grey
    greyish: "#E2E8F0", // light grey
    bg1: "#F2F5FA",
    bg2: "#ECF1FE",
    blueish: "#CCDFFF", // grey bluish
    white: "#FFFFFF", //
    green: "#04862C",
    red: "#D50000",
  },
};
